@if (tasksList && tasksList.length) {
  <div>
    <mat-list>
      @for (task of tasksList; track task; let i = $index) {
        <mat-list-item>
          @if (task.weightLevel >= 99) {
            <mat-icon matListItemAvatar class="highest">warning</mat-icon>
          }
          @if (task.weightLevel >= 80 && task.weightLevel < 99) {
            <mat-icon matListItemAvatar class="high">
              notification_important
            </mat-icon>
          }
          @if (task.weightLevel < 80) {
            <mat-icon matListItemAvatar>notifications</mat-icon>
          }
          <h3 matListItemTitle>{{ task.title }}</h3>
          @if (!dense) {
            <span matListItemLine class="message-line">{{ task.message }}</span>
          }
          <div matListItemLine class="text-gray task-actions">
            {{ task.actionDateTime | date : 'dd/MM/yyyy HH:mm'}}
            @if (isAdmin && !task['showCommentBox'] && task.comments?.length === 0) {
              <a
                (click)="showCommentBox(task)"
                href="javascript:void(0)"
                >
                <mat-icon>chat_bubble_outline</mat-icon>
                Commenter
              </a>
            }
          </div>
          <button class="btn-task" mat-stroked-button (click)="setTaskCompleted(task)" [disabled]="isBusy || !isAdmin">Marquer comme traité</button>
        </mat-list-item>
        @if (task['showCommentBox'] || task.comments?.length) {
          <div class="comments">
            <app-log-comments-list [activity]="task" [showCommentBox]="task['showCommentBox']"></app-log-comments-list>
          </div>
        }
        @if (i < tasksList.length - 1) {
          <mat-divider></mat-divider>
        }
      }
    </mat-list>
  </div>
}
